var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-card-wrap"},[_c('div',{staticClass:"blog-cards container"},_vm._l((_vm.blogPosts),function(post,index){return _c('BlogCard',{key:index,attrs:{"post":post}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }